import React, { useState, useEffect } from 'react';
import { Person, OntotisDropDown, PositionDropDown } from '../../../utils/types';
import { addAssingPosition, deleteAssingPosition, updateAssingPosition } from '../../../utils/apicall/personsApi';
import { AxiosResponse } from 'axios';
import { processError } from '../../../utils/error/errorUtils';
import ErrorAlert from '../../../components/ErrorAlert';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal';
import { authService } from '../../../utils/authServices';
import { useNavigate } from 'react-router-dom';
import { CONFIG } from '../../../utils/config';
// Define the response data structure
interface UpdateData {
  message: string;
}

const SectionPersonAssignments: React.FC<{ personData: Person; ontotisDropDown: OntotisDropDown[]; positionDropDown: PositionDropDown[], onRefresh: () => void }> = ({
  personData,
  ontotisDropDown,
  positionDropDown,
  onRefresh,
}) => {
  const [formData, setFormData] = useState<{ontoti_id?: number; position_id?: number }>({});
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState<number | null>(null);
  const primaryRole = authService.getPrimaryRole();
  const navigate = useNavigate(); // Initialize useNavigate
  useEffect(() => {
    // Set initial form data to current position if available

  }, [personData]);

  const [assignments, setAssignments] = useState(() => 
  personData.positions.map((position) => {
    const ontoti = personData.ontotis.find((ontoti) => ontoti.id === position.pivot.ontoti_id);
    return {
      position,
      ontoti,
      pivot_id: position.pivot.pivot_id,
      person_id: position.pivot.person_id,
      position_id: position.pivot.position_id,
      ontoti_id: position.pivot.ontoti_id,
    };
  })
);

  const handleChangePosition = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: Number(value) }));
  };



  
  const handleAddPosition = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await addAssingPosition({
        person_id: personData.id,
        ontoti_id: formData.ontoti_id,
        position_id: formData.position_id,
      });
      setSuccessMessage('Η ενημέρωση επιτυχής');
      onRefresh(); // Notify parent to reload data
    } catch (error) {
      console.error('Failed to add position:', error);
      processError(error, setErrors, setErrorMessage, setSuccessMessage);
    }
  };

  /*const handleRemovePosition = async (pivotId: number) => {
      try {
        await deleteAssingPosition(pivotId);
        setSuccessMessage('Η διαγραφή πέτυχε');
        onRefresh(); // Notify parent to reload data
      } catch (error) {
        console.error('Failed to delete position:', error);
        processError(error, setErrors, setErrorMessage, setSuccessMessage);
      }
    
  };*/

  const handleRemovePosition = async (pivotId: number) => {
    setDeleteID(pivotId);
    if (primaryRole=='unitadmin'){
      if (assignments.length == 1) {
      setShowDeleteModal(true);
      }else{
        handleDelete(pivotId);
      }
    }else{
      handleDelete(pivotId);
    }
  
  };

   const handleDelete = async(pivotId: number) => {
    try {
      await deleteAssingPosition(pivotId);
  
      // Check if there are any remaining assignments after the deletion
      const remainingAssignments = assignments.filter(
        (assignment) => assignment.pivot_id !== pivotId
      );
      setShowDeleteModal(false);
      const updatedAssignments = assignments.filter((assignment) => assignment.pivot_id !== pivotId);
      setAssignments(updatedAssignments);

      if (remainingAssignments.length > 0) {
        setSuccessMessage('Η διαγραφή πέτυχε');
        onRefresh(); // Notify parent to reload data only if there are remaining assignments
      } else {
        setSuccessMessage('Η διαγραφή πέτυχε, αλλά δεν υπάρχουν πλέον αντιστοιχίες οντότητας.');
       
          setTimeout(() => {
            navigate(CONFIG.urls.getPersonsUrl_Admin());
          
              window.location.reload();
           
          }, 300);
      
      }
    } catch (error) {
      console.error('Failed to delete position:', error);
      processError(error, setErrors, setErrorMessage, setSuccessMessage);
    }
  };

  return (
    <section className="ontotita py-1">
        {/* Success Alert */}

       <div className="container mt-4">
          <div className="card p-5">
          <h2 className="h5 mb-2 text-primary">Διαχείριση Αντιστοιχιών Προσώπου / Θέσης / Υπηρεσίας</h2>
          {successMessage && (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                <strong></strong> {successMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
                            {errorMessage && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <strong></strong> {errorMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
          <hr />
          <div className="mb-4">
            <h4 className="h6 text-secondary">Τρέχουσες Αντιστοιχίες</h4>
            <ul className="list-group mb-4">
              {assignments.map((assignment, index) => (
                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                  {assignment.ontoti ? `${assignment.ontoti.title}` : 'Οντότητα μη διαθέσιμη'} - {assignment.position.title}
                  {/*<button className="btn btn-danger btn-sm" onClick={() => handleRemovePosition(assignment.position.pivot.pivot_id)}>Αφαίρεση</button>*/}
                  <button className="btn btn-danger btn-sm" onClick={() => handleRemovePosition(assignment.position.pivot.pivot_id)}>Αφαίρεση</button>
                </li>
              ))}
            </ul>

          
                 
                            {/* Delete Confirmation Modal */}
                            <DeleteConfirmationModal
                                show={showDeleteModal}
                                onConfirm={() => handleDelete(deleteID!)}
                                onCancel={() => setShowDeleteModal(false)} // Just close the modal
                                title="Επιβεβαίωση Διαγραφής"
                                message="Προσοχή! Αυτή η σχέση προσσωπου με οντότητα είναι μοναδική. Έαν διαγραφεί δεν θα έχετε πρόσβαση στην επεξεργασία αυτού του προσώπου.
                                 Είστε βέβαιοι;"
                                confirmText="Ναι, Διαγραφή"
                                cancelText="Ακύρωση"
                            />
                          </div>
   

          <h4 className="h6 text-secondary">Προσθήκη Νέας Αντιστοιχίας</h4>
          <form onSubmit={handleAddPosition} className="row g-3">
            <div className="col-md-6">
              <label htmlFor="ontoti_id" className="form-label">Οντότητα</label>
              <div className="input-group">
                <span className="input-group-text"><i className="bi bi-diagram-3"></i></span>
                <select
                  id="ontoti_id"
                  name="ontoti_id"
                  className="form-select"
                  required
                  onChange={handleChangePosition}
                  value={formData.ontoti_id || ''}
                >
                  <option value="">Επιλέξτε Οντότητα</option>
                  {ontotisDropDown.map((item) => (
                    <option key={item.id} value={item.id} disabled={!item.can_edit} >
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <label htmlFor="position_id" className="form-label">Θέση</label>
              <div className="input-group">
                <span className="input-group-text"><i className="bi bi-briefcase"></i></span>
                <select
                  id="position_id"
                  name="position_id"
                  className="form-select"
                  required
                  onChange={handleChangePosition}
                  value={formData.position_id || ''}
                >
                  <option value="">Επιλέξτε Θέση</option>
                  {positionDropDown.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-12 text-end mt-3">
              <button type="submit" className="btn btn-primary">Προσθήκη Αντιστοιχίας</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SectionPersonAssignments;
